import React from 'react';

class IntegrationsPageAudienceSize extends React.Component {
    render() {
        return (
            <React.Fragment>
            
                <div class="col-md-5 col-lg-5 offset-lg-1">
                    <h5 class="text-muted fw-normal mt-2 mb-0 text-truncate" title="Campaign Sent">Audience size</h5>
                    <h6>
                        <span data-plugin="counterup" class="min-width-60">1298</span>
                        <span class="text-success me-2">
                            <span class="mdi mdi-arrow-up-bold"></span>
                            6.74%
                        </span>
                    </h6>
                </div>

            </React.Fragment>
        );
    }
}

export default IntegrationsPageAudienceSize;
